import { UpdateFilterAction } from '../slice/alerts.types';

export function toggleFilterSelection(
  selectedFilters: Record<string, Record<string, boolean>>,
  options: UpdateFilterAction,
) {
  const { categoryKey, optionKey } = options;

  const currentFilterState = selectedFilters[categoryKey] || {};

  const isFilterSelected = currentFilterState[optionKey];

  // Add or remove the option filter from the global filters state object
  if (isFilterSelected) {
    // Remove the entire category if there are no options left
    if (Object.keys(currentFilterState).length === 1) {
      delete selectedFilters[categoryKey];
    } else {
      delete currentFilterState[optionKey];
    }
  } else {
    selectedFilters[categoryKey] = { ...currentFilterState, [optionKey]: true };
  }
}
